import { useCallback } from 'react'
import { toMoment } from 'utils/toMoment'
import { addDaysToDate } from 'shared'

/**
 * the default numDays value is 28
 *
 * @param placementDate a ConcreteTestSet.placementDate in ISO 8601 date string format
 * @see {@link toMoment}
 * @see {@link addDaysToDate}
 */
export function useBreakDateByPlacementDate(placementDate?: string | null) {
  return useCallback<(numDays?: number) => ReturnType<typeof toMoment>>(
    (numDays = 28) => toMoment(addDaysToDate({ numDays, date: placementDate })),
    [placementDate]
  )
}
